import React, { useEffect, useState } from "react";
import styled from "@mui/system/styled";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";

const GroupLabel = styled("div")({
  textOverflow: "ellipsis",
  overflow: "hidden",
  width: "14.25rem",
  whiteSpace: "nowrap",
});

const SharedDashboardDialog = (props) => {
  const [requestPending, setRequestPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [dashboardGroups, setDashboardGroups] = useState([]);

  const { dashboard, groups, share, open, handleClose } = props;

  useEffect(() => {
    setDashboardGroups(dashboard.acu_groups ?? []);
  }, [dashboard.acu_groups]);

  async function shareDashboard() {
    setRequestPending(true);
    const results = await share(dashboardGroups);
    if (results.error) {
      setErrorMessage(results.error);
    } else {
      handleClose();
    }
    setRequestPending(false);
  }

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="sm"
      aria-labelledby="template-dialog-title"
    >
      <DialogTitle id="template-dialog-title">
        Share Dashboard with Groups
      </DialogTitle>
      <DialogContent>
        <FormControl variant="standard" component="fieldset">
          <FormGroup row>
            {groups.map((group) => (
              <FormControlLabel
                key={group.guuid}
                control={
                  <Checkbox
                    checked={dashboardGroups.indexOf(group.guuid) !== -1}
                    onChange={(event) =>
                      setDashboardGroups((groups) =>
                        event.target.checked
                          ? [...groups, group.guuid]
                          : groups.filter((g) => g !== group.guuid)
                      )
                    }
                    name={group.name}
                  />
                }
                label={
                  <Tooltip title={group.name}>
                    <GroupLabel>{group.name}</GroupLabel>
                  </Tooltip>
                }
              />
            ))}
          </FormGroup>
        </FormControl>
        {errorMessage && (
          <DialogContentText style={{ color: "red" }}>
            {errorMessage}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} style={{ color: "red" }}>
          Cancel
        </Button>
        <Button
          disabled={requestPending}
          onClick={shareDashboard}
          color="primary"
        >
          Save
        </Button>
        {requestPending && <CircularProgress size={20} color="primary" />}
      </DialogActions>
    </Dialog>
  );
};

export default SharedDashboardDialog;
